import React from 'react'
import { Circle, Group, Line } from 'react-konva'

const Annotation: React.FC<{
    closed: boolean
    flattenedPoints: any
    lines: any
    points: any
}> = (props) => {
    const vertexRadius = 8

    return (
        <Group name="polygon" preventDefault={false}>
            <Line points={props.flattenedPoints} closed={props.closed} stroke="#00F1FF" strokeWidth={8} />
            {props.closed &&
                props.lines.map((line: any) => {
                    const line_style =
                        line.ref === true
                            ? {
                                  stroke: '#ffdb28'
                              }
                            : {
                                  stroke: '#00F1FF'
                              }
                    return (
                        <Line
                            key={line.name}
                            name={line.name}
                            points={line.points.flat()}
                            strokeWidth={8}
                            fill="rgb(140,30,255,0.5)"
                            listening={false}
                            {...line_style}
                        />
                    )
                })}
            {props.points.map((point: any, index: number) => (
                <Circle
                    key={index}
                    x={point[0]}
                    y={point[1]}
                    radius={vertexRadius}
                    listening={false}
                    fill="#e95d95"
                    stroke="#515151"
                    strokeWidth={2}
                />
            ))}
        </Group>
    )
}

export default Annotation
